const commonTranslation = {
  hello: "Hello",
  welcome: "Welcome",
  english: "English",
  german: "German",
  italian: "Italian",
  french: "French",
  currentLanguage : "en-US"
};

const loginComponent = {
  email: "Email",
  emailAddress: "Email Address",
  username: "User name",
  password: "Password",
  login: "Login",
  signUp: "Sign up",
  multifactorAuthentication: "Multifactor authentication",
  OTPCode: "OTP code",
  verifyAndProceed: "Verifiy & Proceed",
  resendOTP: "Resend OTP",
  readMore: "Read more",
  logout: "Logout",
  loginOrSignup: "Log in",
  loginWelcome: "Welcome back! Please enter your details.",
  enterEmail: "Enter your email",
  enterPassword: "Password",
  getStarted: "Get Started!",
  profile: "Profile",
  assignment_confirmation: "Assignment confirmation",
  revoke_confirmation:"Revoke confirmation",
  verificationRequired: "Verification Required",
  verificationDescription: "Enter the code shown in your authenticator app",
  no_content : "No content",
  loginRemember: "Remember me for 24 hours",
  ForgotPassword: "Forgot password",
  NoAccount: "Don’t have an account?",
  loginAppInfo: "I don’t have access to my Authenticator App",
  loginSuccess: "Login Successful",
  loginError: "Login Error",
};

const dashboardComponent = {
	gridView: "Grid view",
	tableView: "Table view",
	PDFExtraction: "FNOL Dashboard",
	search: "Search",
	filter: "Filter",
	filters: "Filters",
	sortBy: "Sort by",
	refresh: "Refresh",
	sort: "Sort",
	sortFields: "Sort-Fields",
	edit: "Edit",
	download: "Download",
	versionHistory: "Version History",
	documentName: "Document Name",
	asc: "ASC",
	desc: "DESC",
	operator: "Operator",
	receiverName: "Receiver Name",
	receiver: "Receiver",
	extractedAt: "Extracted",
	lastModified: "Last Modified",
	noOfPages: "No. Pages",
	status: "Status",
	action: "Action",
	details: "Details",
	generalInformation: "General Information",
	medicine_info: "Medicine Information",
	invoice: "Invoice",
	invoiceDate: "Invoice Date",
	invoiceReference: "Invoice Reference",
	vetName: "Vet Name",
	vetStreet: "Vet Street",
	city: "City",
	postalCode: "Postal Code",
	language: "Language",
	policyholderName: "Policyholder Name",
	policyholderAddress: "Policyholder Street",
	treatment: "Treatment",
	treatmentDate: "Treatment Date",
	diagnosis: "Diagnosis",
	itemName: "Item name",
	quantity: "Qty",
	prize: "Price",
	VAT: "VAT",
	addTreatment: "Add Treatment",
	addItem: "Add Item",
	total: "Total",
	subTotal: "Sub total",
	calculatedSum: "Calculated Total Sum After Discount",
	notes: "Notes",
	page: "Page",
	pages: "Pages",
	min: " Min",
	mins: " Mins",
	hour: " Hour",
	hours: " Hours",
	day: " Day",
	days: " Days",
	month: " month",
	months: " months",
	ago: "ago",
	modifiedBy: "Modified by",
	modifiedAt: "Modified at",
	clickASC: "Click to sort ascending",
	clickDESC: "Click to sort descending",
	petName: "Pet Name",
	items: "Items",
	treatmentName: "Treatment Name",
	InvoiceTotalSumPriceWithoutVAT: "Invoice Total Sum Price Without VAT",
	InvoiceTotalSumPriceWithVAT: "Invoice Total Sum Price With VAT",
	CalculatedTotalSum: "Calculated Total Sum",
	TotalDiscountAmount: "Total Discount Amount",
	CalculatedTotalSumAfterDiscount: "Calculated Total Sum After Discount",
	recent: "Recent",
	viewHistory: "View History",
	remember: "Don't ask again today",
	rememberSentance:
		"We will not ask for a verification code again today on your trusted device when you log in.",
	Complete_login: "Complete Login",
	date: "Date",
	time: "Time",
	note: "Notiz",
	comment: "Comments",
	revoke: "Revoke",
	deleteTreatment: "Delete treatment",
	deleteItem: "Delete item",
	lastUpdate: "Last Update",
	board: "Board",
	table: "Table",
	modified: "Modified by",
	showing: "Showing",
	totalSum: "Total Sum",
	of: "of",
	none: "None",
	customVAT: "Custom VAT",
	quality_level: "Quality Level",
	good: "Good",
	verify: "Verify",
	not_extracted: "Not Extracted",
	"Missing Data": "Missing Data",
	apply: "Apply",
	copy: "Copy",
	moveToPage: "Move to Page",
	clearSelection: "Clear Selection",
	pasteItem: "Paste Here",
};

const commonEvents = {
  add: "Add",
  update: "Update",
  save: "Save",
  cancel: "Cancel",
  reset: "Reset",
  download: "Download",
  clear: "Clear",
  delete: "Delete",
  assign: "Assign",
  back: "Back",
  resetInitial: "Reset to initial",
  enter_notes: "Enter your notes here...",
  Updated : "Updated",
  Exported : "Exported",
  Revoked: "Revoked",
  Assigned: "Assigned",
  medicineDescription: "Medicine Description",
  purpose: "Purpose",
  usedFor: "Used For",
  petTypes: "Pet Types",
  activeIngredients: "Active Ingredients",
  category: "Category",
  typeOfDamage: "Type of Damage",
  causeOfDamage: "Cause of Damage",
  loading: "Loading..."

};

const documentStatus = {
  not_yet_started: "Not started",
  in_progress: "In progress",
  completed: "Completed",
};

const confirmationMessage = {
  deleteConfirmationTitle: "Delete confirmation",
  deleteActionTreatmentContent:
    "Are you sure you want to delete this treatment? this action can not be undone",
  deleteActionItemContent:
    "Are you sure you want to delete this item? this action can not be undone",
  resetConfirmationTitle: "Reset confirmation",
  resetToInitialConfirmationTitle: "Reset to initial confirmation",
  resetActionContent:
    "Are you sure you want to reset? This action cannot be undone",
  resetInitialActionContent:
    "Are you sure you want to reset to the initial stage? This action cannot be undone",
  assignmentConfirmation:
    "Are you sure you want to assign this document to yourself?",
  revokeConfirmation: "Are you sure you want to unassign this document from yourself?",
  reAssignConfirmation:
    "Are you sure you want to reassign this document to yourself?",
  assignedTo: "This document is assigned to",
};

const errorNotification = {
  invalidEmail: "Please enter a valid email",
  emailEmpty: "Please enter your email",
  passwordEmpty: "Please enter your password",
  notAllowedToEdit: "This document is not allowed to be edited",
  noteNotSaved: "Notes are not being saved",
  tokenExpired: "Your session is expired, please login",
  accessDenied: "Access denied",
  notAssigned: "Kindly assign the document to yourself for access",
};

const successNotification = {
  DocumentResetToInitial : 'Reset to initial successful',
  UpdateSuccess: "Updated Successfully",
  noteSaved: "Notes have been saved successfully",
  successDocumentProgressStatus: "Assignment successful",
  revokeDocument: "Assignment revoked",
}

export const enJSON = {
  ...commonEvents,
  ...loginComponent,
  ...dashboardComponent,
  ...errorNotification,
  ...commonTranslation,
  ...documentStatus,
  ...confirmationMessage,
  ...successNotification
};
